/* eslint-disable no-use-before-define */
import React, { useRef } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import KenTextLabel from '../KenTextLabel/index';
import Popper from '@material-ui/core/Popper';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(0),
    },
  },
}));
const styles = (theme) => ({
  popper: {
    width: "fit-content"
  }
});

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};

export default function KenAutoComplete(props) {
  const classes = useStyles();
  console.log('ken', props.value);
  return (
    <div className={classes.root}>
      <KenTextLabel label={props.label} required={props.required} />
      <Autocomplete
        PopperComponent={PopperMy}
        multiple={props.multiple != undefined ? props.multiple : true}
        limitTags={2}
        ref={props.ref}
        name={props.name}
        id="multiple-limit-tags"
        options={props.options}
        value={props.value}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => {
          console.log('kenparams', params);
          return (
            <TextField
              name="duration"
              {...params}
              variant={props.variant}
              placeholder={props.placeholder}
            />
          );
        }}
      />
    </div>
  );
}
